
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { usePicwordPetAdd } from '@/modules/picword/pet/model/add';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.PET.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, rewardV$, actions, SelectableBooster } = usePicwordPetAdd();

        return { v$, rewardV$, model, actions, SelectableBooster };
    }
});
